const TOPIC_FAVOURITES_STORAGE_KEY = "favourites";
const DRUG_INDEX_FAVOURITES_STORAGE_KEY = "drugIndexFavourites";
const DRUG_INDEX_FAVOURITE_TYPE = "drugIndex";

function getFavourites(storageKey = TOPIC_FAVOURITES_STORAGE_KEY) {
  const storedFavourites = localStorage.getItem(storageKey);
  if (!storedFavourites) {
    return [];
  }

  try {
    const data = JSON.parse(storedFavourites);
    return data || [];
  } catch (e) {
    return [];
  }
}

function getTocSectionId(filePath) {
  if (!filePath) return null;

  try {
    const tocContainer = document.getElementById("tg_toc_id");
    if (!tocContainer) return null;

    const tocElement = tocContainer.querySelector(`[href*="${filePath}"]`);
    if (!tocElement) return null;

    return tocElement.getAttribute("mpspath");
  } catch (e) {
    console.error("Error getting TOC sectionId:", e);
    return null;
  }
}
function saveFavourite(
  favouriteTitle,
  favouriteUrl,
  type,
  topicSection,
  sectionId,
  storageKey = TOPIC_FAVOURITES_STORAGE_KEY,
) {
  const newFavourites = [...getFavourites(storageKey)];
  let added = true;
  if (hasFavourite(favouriteTitle, type, storageKey)) {
    added = false;
    newFavourites.splice(getFavouriteIndex(newFavourites, favouriteTitle, type), 1);
  } else {
    const favourite = { favouriteTitle, favouriteUrl, type, topicSection };
    if (type === "subtopic" && sectionId) {
      const msPathViaFilePath = getTocSectionId(sectionId);
      if (msPathViaFilePath) {
        favourite.favouriteUrl = msPathViaFilePath;
        favourite.sectionId = sectionId;
      }
    }
    newFavourites.push(favourite);
  }
  localStorage.setItem(storageKey, JSON.stringify(newFavourites));
  return added;
}

function getFavouriteIndex(newFavourites, favouriteTitle, type) {
  return newFavourites.findIndex(
    (favourite) => favourite.favouriteTitle === favouriteTitle && favourite.type === type,
  );
}

function hasFavourite(favouriteTitle, type, storageKey = TOPIC_FAVOURITES_STORAGE_KEY) {
  return getFavouriteIndex(getFavourites(storageKey), favouriteTitle, type) !== -1;
}

function clearFavourites(storageKey = TOPIC_FAVOURITES_STORAGE_KEY) {
  localStorage.removeItem(storageKey);
}

export {
  TOPIC_FAVOURITES_STORAGE_KEY,
  DRUG_INDEX_FAVOURITES_STORAGE_KEY,
  DRUG_INDEX_FAVOURITE_TYPE,
  getFavourites,
  saveFavourite,
  hasFavourite,
  clearFavourites,
};
